import React, { ChangeEvent, useRef } from "react";
import Table from "../Table";
import { CONSTANTS } from "../../constants/Constants";
import Button from "../Buttons";
import QuestionsModal from "../QuestionsModal";

interface QAProps {
  payload: any;
  setPayload: any;
  isModalOpen: boolean;
  setIsModalOpen: any;
  quesChangeHandler: (e: ChangeEvent) => void;
  saveQuesHandler: () => void;
  newQuestion: any;
  setNewQuestion: any;
  setCurrentIndex: any;
}

const QuestionAndAnswers: React.FC<QAProps> = ({
  payload,
  setPayload,
  setIsModalOpen,
  isModalOpen,
  quesChangeHandler,
  saveQuesHandler,
  newQuestion,
  setNewQuestion,
  setCurrentIndex,
}) => {
  const dragItem = useRef<number | null>(null);
  const dragOverItem = useRef<number | null>(null);

  const filteredRows = payload?.[
    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_QUESTIONS
  ]?.map((answer: any) => ({
    question:
      answer[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.QUESTION],
    answer:
      answer[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.ANSWER] ||
      answer[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.DESCRIPTION],
    status: answer[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.STATUS],
  }));

  const handleDragEnd = () => {
    if (
      dragItem.current !== null &&
      dragOverItem.current !== null &&
      dragItem.current !== dragOverItem.current
    ) {
      const updatedQA = [
        ...payload[
        CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_QUESTIONS
        ],
      ];
      const [draggedItem] = updatedQA.splice(dragItem.current, 1);
      updatedQA.splice(dragOverItem.current, 0, draggedItem);

      const updatedQAWithPosition = updatedQA.map((qa, index) => ({
        ...qa,
        position: index + 1,
      }));
      setPayload({
        ...payload,
        [CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_QUESTIONS]:
          updatedQAWithPosition,
      });
    }
    dragItem.current = null;
    dragOverItem.current = null;
  };

  return (
    <div className="lg:p-6">
      <h2 className="text-2xl font-semibold mb-4">{CONSTANTS.QNA_TXT}</h2>
      <div className="overflow-auto">

        <Table
          dragItem={dragItem}
          tableHeader={filteredRows.length > 0 ? [
            CONSTANTS.QUESTION_TXT,
            CONSTANTS.ANSWER_TXT,
            CONSTANTS.SHOW_ON_PROFILE_TXT,
          ] : []}
          tableRows={filteredRows}
          dragEndHandler={handleDragEnd}
          dragOverItem={dragOverItem}
          rowClickHandler={(index) => {
            setNewQuestion(
              payload[
              CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                .RESOURCE_QUESTIONS
              ][index]
            );
            setIsModalOpen(true);
            setCurrentIndex(index);
          }}
        />
      </div>
      <div className="w-32 mt-4">
        <Button
          btn_label={CONSTANTS.ADD_MORE}
          on_click_handler={() => {
            setIsModalOpen(true);
            setNewQuestion({
              status: CONSTANTS.ENABLED_TXT.toLocaleUpperCase(),
            });
            setCurrentIndex(null);
          }}
          other_classes={"!rounded"}
          type={"primary"}
        />
      </div>

      {isModalOpen && (
        <QuestionsModal
          setIsModalOpen={setIsModalOpen}
          payload={newQuestion}
          quesChangeHandler={quesChangeHandler}
          saveQuesHandler={saveQuesHandler}
        />
      )}
    </div>
  );
};

export default QuestionAndAnswers;
